module.exports = __webpack_public_path__ + "img/whatsapp-brands.8488339c.svg";